__turbopack_context__.v({
  "dialInCountry": "dialInItem-module-scss-module__EPea6W__dialInCountry",
  "dialInCountryName": "dialInItem-module-scss-module__EPea6W__dialInCountryName",
  "dialInPhone": "dialInItem-module-scss-module__EPea6W__dialInPhone",
  "flagIcon": "dialInItem-module-scss-module__EPea6W__flagIcon",
  "row": "dialInItem-module-scss-module__EPea6W__row",
});
